
import React from 'react';
import { User, FileText, CreditCard } from 'lucide-react';
import { Task } from '@/hooks/useTaskNotifications';

export interface TaskWithIcon extends Task {
  icon: React.ReactNode;
}

export const addIconsToTasks = (tasks: Task[]): TaskWithIcon[] => {
  return tasks.map(task => ({
    ...task,
    icon: getTaskIcon(task.id)
  }));
};

const getTaskIcon = (taskId: string) => {
  switch (taskId) {
    case 'profile':
      return <User size={16} />;
    case 'payment':
      return <CreditCard size={16} />;
    default:
      return <FileText size={16} />;
  }
};
